module.exports = __webpack_public_path__ + "img/house-item3.648cea62.jpg";